function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { normalizeArguments } from './parsePhoneNumber';
import PhoneNumberMatcher from './PhoneNumberMatcher';

/**
 * @return ES6 `for ... of` iterator.
 */
export default function searchNumbers() {
	var _normalizeArguments = normalizeArguments(arguments),
	    text = _normalizeArguments.text,
	    options = _normalizeArguments.options,
	    metadata = _normalizeArguments.metadata;

	var matcher = new PhoneNumberMatcher(text, options, metadata);

	return _defineProperty({}, Symbol.iterator, function () {
		return {
			next: function next() {
				if (matcher.hasNext()) {
					return {
						done: false,
						value: matcher.next()
					};
				}
				return {
					done: true
				};
			}
		};
	});
}
//# sourceMappingURL=searchNumbers.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/libphonenumber-js/es6/searchNumbers.js
// module id = ../../../../libphonenumber-js/es6/searchNumbers.js
// module chunks = 3